import React from 'react';

export function TwoColumnPage({
  leftContent,
  rightContent,
  stickyHeaderDesktop = false,
}: {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  stickyHeaderDesktop?: boolean;
}) {
  return (
    <div className="relative flex min-h-page justify-center overflow-x-hidden md:min-h-md-page lt:overflow-x-clip">
      <div className="flex w-full gap-20 px-4 pb-6 md:px-6 dt:max-w-content">
        <div className="min-w-0 flex-1">{leftContent}</div>
        {rightContent && (
          <div
            className={`sticky ${
              stickyHeaderDesktop ? `top-20` : `top-8`
            } mt-3 hidden h-fit flex-[0_0_304px] lt:flex`}
          >
            {rightContent}
          </div>
        )}
      </div>
    </div>
  );
}
